import { useNavigate } from 'react-router-dom'
import { useToast } from '@/hooks/use-toast'
import { useCampaign } from '@/hooks/useCampaign'
import { useCreateCampaignMutation } from '@/redux/marketerApi'

/**
 * Saves what's filled in so far as a draft campaign (not in the Marketplace yet) and opens it.
 * Needs a name and a brand.
 */
export const useSaveDraft = () => {
  const { campaignData, resetCampaign } = useCampaign()
  const [createCampaign, { isLoading }] = useCreateCampaignMutation()
  const navigate = useNavigate()
  const { toast } = useToast()
  const save = async () => {
    const { basics } = campaignData
    if (!basics.name.trim() || !basics.brand) {
      toast({ title: 'Add a name and a brand first', variant: 'destructive' })
      return
    }
    try {
      const res: any = await createCampaign({ ...campaignData, saveAsDraft: true } as any).unwrap()
      toast({ title: 'Draft saved', description: `"${basics.name}" is in your campaigns.` })
      resetCampaign()
      navigate(`/campaign/${res.data.id}`)
    } catch (err: any) {
      toast({
        title: "Couldn't save the draft",
        description: err?.data?.error ?? 'Try again in a moment.',
        variant: 'destructive',
      })
    }
  }
  return { save, saving: isLoading }
}
